const getSubdomain = () => (window.location.host.split(".")[0]);

export default getSubdomain;
